// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresSquareAssignBody = {
  poolId: string;
  gridId: string;
  squareKey: string;
  assignee: { ownerKind: "member" | "guest"; ownerId: string } | null;
};

export type typeSquaresSquareAssignOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    squareKey: string;
    ownerKind?: "member" | "guest" | null;
    ownerId?: string | null;
  };
};

export type typeSquaresSquareAssignOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresSquareAssignOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresSquareAssignOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresSquareAssignBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    gridId: { type: "string", maxLength: 3000, minLength: 1 },
    squareKey: { type: "string", maxLength: 3000, minLength: 1 },
    assignee: {
      oneOf: [
        {
          type: "object",
          properties: {
            ownerKind: { type: "string", enum: ["member", "guest"] },
            ownerId: { type: "string", maxLength: 3000, minLength: 1 },
          },
          required: ["ownerKind", "ownerId"],
        },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId", "gridId", "squareKey", "assignee"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresSquareAssign(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresSquareAssignBody);
  }

  return async function postSquaresSquareAssign(
    payload: typeSquaresSquareAssignBody,
  ): Promise<
    typeSquaresSquareAssignOutput200 | typeSquaresSquareAssignOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresSquareAssign" failed before calling the network. #ffeb61b8c9d7`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#ffeb61b8c9d7" },
        },
        data: null,
      } as typeSquaresSquareAssignOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/square-assign`,
      httpMethod: "POST",
      options,
    })) as typeSquaresSquareAssignOutput200 | typeSquaresSquareAssignOutput400;
  };
}
